import { useCallback } from 'react';

import { NextButton, PrevButton } from '@/shared-components/buttons/components/SliderControls';

/**
 * Minimal header-aligned slider controls for Discover carousels.
 * Accepts a ref to the FHSlider viewport element.
 */
export default function DiscoverHeaderControls({ viewportRef, className = '' }) {
  const getViewport = () => viewportRef?.current || null;

  const slideTo = useCallback((direction) => {
    const el = getViewport();
    if (!el) return;
    const scrollLeft = el.scrollLeft;
    const slides = Array.from(el.children);
    if (!slides.length) return;

    let closestIdx = 0;
    let minDiff = Infinity;
    slides.forEach((slide, idx) => {
      const diff = Math.abs(slide.offsetLeft - scrollLeft);
      if (diff < minDiff) {
        minDiff = diff;
        closestIdx = idx;
      }
    });

    const targetIdx = direction === 'next' ? closestIdx + 1 : closestIdx - 1;
    if (targetIdx < 0 || targetIdx >= slides.length) return;
    el.scrollTo({ left: slides[targetIdx].offsetLeft, behavior: 'smooth' });
  }, [viewportRef]);

  return (
    <div className={`discover-header__controls ${className}`} aria-label="slider controls">
      <PrevButton className="slider-controls__button--minimal" onClick={() => slideTo('prev')} />
      <NextButton className="slider-controls__button--minimal" onClick={() => slideTo('next')} />
    </div>
  );
}
